/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_To_Play_What_BodyInputs */

const bn_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কান্ট্রি ড্যাশ হল একটি গ্লোব-ভিত্তিক ভূগোল খেলা। প্রতিটি রাউন্ড একটি অবস্থান হাইলাইট করে, এবং আপনার কাজ হল সঠিক দেশের নাম টাইপ করা।`)
};

const de_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash ist ein weltbasiertes Geografiespiel. In jeder Runde wird ein Ort hervorgehoben und Ihre Aufgabe besteht darin, den korrekten Ländernamen einzugeben.`)
};

const el_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το Country Dash είναι ένα παιχνίδι γεωγραφίας που βασίζεται σε υδρόγειο. Κάθε γύρος επισημαίνει μια τοποθεσία και η δουλειά σας είναι να πληκτρολογήσετε το σωστό όνομα χώρας.`)
};

const en_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash is a globe-based geography game. Each round highlights one location, and your job is to type the correct country name.`)
};

const es_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash es un juego de geografía basado en el mundo. Cada ronda resalta una ubicación y tu trabajo es escribir el nombre correcto del país.`)
};

const fr_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash est un jeu de géographie sur globe. Chaque manche met un lieu en évidence, et votre objectif est de saisir le bon nom de pays.`)
};

const hi_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कंट्री डैश एक विश्व-आधारित भूगोल खेल है। प्रत्येक राउंड एक स्थान को हाइलाइट करता है, और आपका काम सही देश का नाम टाइप करना है।`)
};

const hu_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Country Dash egy földgömb alapú földrajzi játék. Minden kör egy helyet emel ki, és az Ön feladata a helyes országnév beírása.`)
};

const id_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash adalah permainan geografi berbasis dunia. Setiap putaran menyoroti satu lokasi, dan tugas Anda adalah mengetikkan nama negara yang benar.`)
};

const it_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash è un gioco di geografia basato sul globo. Ogni round evidenzia una posizione e il tuo compito è digitare il nome del paese corretto.`)
};

const ja_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash は地球儀ベースの地理ゲームです。各ラウンドで 1 つの場所が強調表示され、正しい国名を入力することがあなたの仕事です。`)
};

const ko_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash는 지구 기반 지리 게임입니다. 각 라운드마다 하나의 위치가 강조 표시되며, 귀하의 임무는 올바른 국가 이름을 입력하는 것입니다.`)
};

const nl_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash is een wereldgeografiespel. Elke ronde belicht één locatie en het is jouw taak om de juiste landnaam in te typen.`)
};

const pl_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash to gra geograficzna obejmująca cały świat. W każdej rundzie podświetlana jest jedna lokalizacja, a Twoim zadaniem jest wpisanie prawidłowej nazwy kraju.`)
};

const pt_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash é um jogo geográfico baseado no globo. Cada rodada destaca um local e sua tarefa é digitar o nome correto do país.`)
};

const ru_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash — это географическая игра, основанная на земном шаре. В каждом раунде выделяется одно место, и ваша задача — ввести правильное название страны.`)
};

const sv_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash är ett världsbaserat geografispel. Varje omgång markerar en plats, och ditt jobb är att skriva in rätt landsnamn.`)
};

const tr_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash dünya tabanlı bir coğrafya oyunudur. Her turda bir konum vurgulanır ve göreviniz doğru ülke adını yazmaktır.`)
};

const uk_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash — це географічна гра на основі глобуса. У кожному раунді виділяється одне місце, а ваше завдання — ввести правильну назву країни.`)
};

const vi_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash là một trò chơi địa lý dựa trên toàn cầu. Mỗi vòng đánh dấu một địa điểm và công việc của bạn là nhập đúng tên quốc gia.`)
};

const zh_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash 是一款全球地理游戏。每一轮都会突出显示一个位置，您的任务是输入正确的国家/地区名称。`)
};

const zh_hant_how_to_play_what_body = /** @type {(inputs: How_To_Play_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash 是一款全球地理遊戲。每一輪都會突出顯示一個位置，您的任務是輸入正確的國家/地區名稱。`)
};

/**
* | output |
* | --- |
* | "Country Dash is a globe-based geography game. Each round highlights one location, and your job is to type the correct country name." |
*
* @param {How_To_Play_What_BodyInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const how_to_play_what_body = /** @type {((inputs?: How_To_Play_What_BodyInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_To_Play_What_BodyInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_how_to_play_what_body(inputs)
	if (locale === "de") return de_how_to_play_what_body(inputs)
	if (locale === "el") return el_how_to_play_what_body(inputs)
	if (locale === "en") return en_how_to_play_what_body(inputs)
	if (locale === "es") return es_how_to_play_what_body(inputs)
	if (locale === "fr") return fr_how_to_play_what_body(inputs)
	if (locale === "hi") return hi_how_to_play_what_body(inputs)
	if (locale === "hu") return hu_how_to_play_what_body(inputs)
	if (locale === "id") return id_how_to_play_what_body(inputs)
	if (locale === "it") return it_how_to_play_what_body(inputs)
	if (locale === "ja") return ja_how_to_play_what_body(inputs)
	if (locale === "ko") return ko_how_to_play_what_body(inputs)
	if (locale === "nl") return nl_how_to_play_what_body(inputs)
	if (locale === "pl") return pl_how_to_play_what_body(inputs)
	if (locale === "pt") return pt_how_to_play_what_body(inputs)
	if (locale === "ru") return ru_how_to_play_what_body(inputs)
	if (locale === "sv") return sv_how_to_play_what_body(inputs)
	if (locale === "tr") return tr_how_to_play_what_body(inputs)
	if (locale === "uk") return uk_how_to_play_what_body(inputs)
	if (locale === "vi") return vi_how_to_play_what_body(inputs)
	if (locale === "zh") return zh_how_to_play_what_body(inputs)
	return zh_hant_how_to_play_what_body(inputs)
});